export const basicDetail =
[
  {
    name:"clientInfo",
     "rule": {
        "required": true
      },
    label:"Client Info",
    type:"dropdown"
  },
  {
    name:"modeofCommunication",
     "rule": {
        "required": true
      },
    label:"Mode of Communication",
    type:"dropdown"
  },
  {
    name:"interactionType",
     "rule": {
        "required": true
      },
    label:"Interaction Type",
    type:"dropdown"
  },
  {
    name:"response",
     "rule": {
        "required": true
      },
    label:"Response",
    type:"text"
  },
  {
    name:"timespent",
     "rule": {
        "required": true
      },
    label:"Timespent",
    type:"text"
  },
  {
    name:"followedUpBy",
     "rule": {
        "required": true
      },
    label:"Followed Up By",
    type:"text"
  },
  {
    name:"followupDateTime",
     "rule": {
        "required": true
      },
    label:"Followup Date Time",
    type:"date"
  },
  {
    name:"status",
     "rule": {
        "required": true
      },
    label:"Status",
    type:"dropdown"
  },
  {
    name:"notes",
     "rule": {
        "required": true
      },
    label:"Notes",
    type:"textarea"
  },
 
]

export const statusDD =
[
  { id:1, name:"Active"},
  { id:0, name:"Inactive"}
]
export const typeDD =
[
  { id:1, name:"Flat"},
  { id:2, name:"Percentage"}
]
export const editMode =
  [
    {
      name:"modTime",
      disabled:true,
       "rule": {
          "required": false
        },
      label:"Mod Time",
      type:"text"
    },
    {
      name:"modBy",
      disabled:true,
       "rule": {
          "required": false
        },
      label:"Mod By",
      type:"text"
    }
  ]
  export const RentersRentersInfoBreadcrumb = [
    {label:"Dashboard", path:"/dashboard"},
    {label:"Registered Renters", path:"/registered-renters"},
    {label:"Renters Info", path:"/renters-info"},
    {label:"Revenue Agreements", path:"/revenue-agreements"},
    {label:"Non Revenue Agreements", path:"/non-revenue-agreements"},
    {label:"Vehicle Inquiries", path:"/vehicle-inquiries"},
    {label:"Renter Log Interactions", path:"/renter-log-interactions"},
    {label:"", path:"/renter-log-interactions"}
]